import {Repo} from "@services/repos/vendors/repo";
import {AxiosPromise} from "axios";

export class AuthRepo extends Repo{
  constructor() {
    super('auth');
  }

  login(query: any, options: any = {}): AxiosPromise {
    return this.http.post(this.getPath('login'), query, null, options)
  }

  refresh(): AxiosPromise {
    return this.http.post(this.getPath('refresh'))
  }

  logout(): AxiosPromise {
    return this.http.delete(this.getPath("logout"))
  }

  check(): AxiosPromise {
    return this.http.get(this.getPath("check"))
  }
}
